import React, { useState } from 'react';
import { Play, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const VideoSection = () => {
    const [isWatchMode, setIsWatchMode] = useState(false);
    const navigate = useNavigate();

    // Video Configuration
    const videoId = "RNwJloU4Flk";
    const backgroundParams = "autoplay=1&mute=1&loop=1&playlist=" + videoId + "&controls=0&showinfo=0&rel=0&modestbranding=1&disablekb=1";
    const watchParams = "autoplay=1&mute=0&controls=1&showinfo=0&rel=0&modestbranding=1";

    return (
        <section className="w-full px-4 md:px-6 py-8 md:py-12">
            <div className="relative w-full h-[600px] md:h-[800px] overflow-hidden rounded-[32px] shadow-2xl bg-black group isolate">

                {/* Background Video */}
                <div className={`absolute inset-0 z-0 transition-all duration-700 ${isWatchMode ? 'pointer-events-auto' : 'pointer-events-none'}`}>
                    <iframe
                        className={`w-full h-full object-cover transition-all duration-700 ${isWatchMode ? 'scale-100 opacity-100' : 'scale-150 md:scale-125 opacity-80'}`}
                        src={`https://www.youtube.com/embed/${videoId}?${isWatchMode ? watchParams : backgroundParams}`}
                        title="NKENNEAI Video"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                        frameBorder="0"
                    ></iframe>

                    {/* Gradient Overlay */}
                    <div className={`absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent transition-opacity duration-700 ${isWatchMode ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}></div>
                </div>

                {/* Close Button for Watch Mode */}
                {isWatchMode && (
                    <button
                        onClick={() => setIsWatchMode(false)}
                        className="absolute top-8 right-8 z-50 bg-white/10 hover:bg-white/20 backdrop-blur-md p-3 rounded-full text-white transition-all duration-300 transform hover:scale-110"
                    >
                        <X size={24} />
                    </button>
                )}

                {/* Main Content */}
                <AnimatePresence>
                    {!isWatchMode && (
                        <div className="relative z-10 w-full h-full flex flex-col justify-end p-8 md:p-14">
                            <motion.div
                                initial={{ opacity: 0, y: 30 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: 20 }}
                                transition={{ duration: 0.8 }}
                                className="max-w-5xl"
                            >
                                <h2 className="text-white text-3xl md:text-5xl font-extrabold font-axiforma leading-tight mb-8 drop-shadow-lg">
                                    Bridging Africa’s Language Gaps With <br className="hidden md:block" />
                                    <span className="text-[#FFB800] relative inline-block">
                                        AI-Powered
                                        <svg className="absolute w-full h-3 -bottom-2 left-0 text-[#FFB800] opacity-80" viewBox="0 0 200 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.00025 6.99997C25.7501 2.99991 75.9999 0.250002 198 2.50004" stroke="currentColor" strokeWidth="3" strokeLinecap="round" /></svg>
                                    </span> Solutions
                                </h2>

                                <p className="text-gray-200 text-lg md:text-xl font-inter font-light mb-8 max-w-lg leading-relaxed">
                                    Experience the future of communication with NKENNEAI. Seamlessly connecting cultures through advanced language technology.
                                </p>

                                <div className="flex flex-col sm:flex-row items-start gap-4">
                                    <button
                                        onClick={() => navigate('/playground')}
                                        className="bg-[#1E6C56] hover:bg-[#154d3d] text-white px-8 py-4 rounded-xl text-lg font-bold transition-all duration-300 shadow-xl shadow-green-900/20 transform hover:-translate-y-1"
                                    >
                                        Discover Playground
                                    </button>

                                    <button
                                        onClick={() => setIsWatchMode(true)}
                                        className="bg-white text-black hover:bg-gray-100 px-8 py-4 rounded-xl text-lg font-bold flex items-center gap-3 transition-all duration-300 shadow-xl transform hover:-translate-y-1"
                                    >
                                        <Play size={22} fill="currentColor" />
                                        Watch Video
                                    </button>
                                </div>
                            </motion.div>
                        </div>
                    )}
                </AnimatePresence>
            </div>
        </section>
    );
};

export default VideoSection;